import useInViewport from "hooks/useInViewport";
import React, { useEffect, useRef } from "react";
import assetPath from "utils/assetPath.utils";
//
import "./galleryItem.component.scss";

export interface GalleryItemDataProps {
  label: string;
  title: string;
  number: string;
  video: string;
  poster: string;
}

interface Props extends GalleryItemDataProps {
  link?: string;
}

const GalleryItem: React.FC<Props> = (props) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const inViewport = useInViewport(videoRef);

  useEffect(() => {
    const video = videoRef.current;
    if (!!video) {
      if (inViewport && video.paused) {
        const promise = video.play();
        promise.then().catch((error) => console.log("video play not possible"));
      } else if (!inViewport && !video.paused) {
        video.pause();
      }
    }
  }, [inViewport]);

  return (
    <div className="gallery-item">
      <div className="gallery-item__inner">
        <div className="gallery-item__top">
          <video
            src={props.video}
            muted
            loop
            playsInline
            poster={assetPath(props.poster)}
            ref={videoRef}
          />
        </div>
        <div className="gallery-item-bottom">
          <span className="gallery-item-bottom__label">{props.label}</span>
          <h5 className="gallery-item-bottom__title">{props.title}</h5>
          <span className="gallery-item-bottom__number">{props.number}</span>
        </div>
        {/* {!!props.link && (
          <a
            href={props.link}
            target="_blank"
            rel="norefferer"
            className="gallery-item__link"
          />
        )} */}
      </div>
    </div>
  );
};

export default GalleryItem;
